import { render, staticRenderFns } from "./BpmBubble.vue?vue&type=template&id=460e13bc&scoped=true"
import script from "./BpmBubble.vue?vue&type=script&lang=js"
export * from "./BpmBubble.vue?vue&type=script&lang=js"
import style0 from "./BpmBubble.vue?vue&type=style&index=0&id=460e13bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e13bc",
  null
  
)

export default component.exports